import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import _ from 'underscore';
import { injectIntl, FormattedMessage } from 'react-intl';
import Addon from './addon';
import './index.scss';

class Addons extends React.PureComponent {
  static displayName = 'BookingRequest-Addons';

  static propTypes = {
    availableAddons: PropTypes.array.isRequired,
    addonAvailability: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.array,
  };

  componentDidMount() {
    const { value } = this.props;
    if (value && value.length) {
      this._removeUnavailableAddons(value);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { time, date, value } = this.props;
    if (prevProps.time === time && prevProps.date === date) return;

    if (value && value.length) {
      this._removeUnavailableAddons(value);
    }
  }

  _removeUnavailableAddons = (propAddons) => {
    const selectedAddons = propAddons.map((val) => ({
      ...val,
      id: parseInt(val.id, 10),
    }));
    const unavailableAddons = _.difference(
      _.pluck(selectedAddons, 'id'),
      _.pluck(this._filterAvailableAddonsProps(), 'id')
    );
    unavailableAddons.map((id) => {
      this.addonUpdated(id, {
        selected: false,
        count: 0,
      });
    });
  };

  addonUpdated = (addonId, state) => {
    this.props.onChange(this.props.name, this._buildNewAddons(addonId, state));
  };

  _buildNewAddons = (addonId, state) => {
    const addons = this._selectedAddonsObject;
    if (state.selected === false) {
      addons[addonId] = 0;
    } else {
      addons[addonId] = state.count;
    }

    return _.chain(addons)
      .pairs()
      .filter((addon) => addon[1] !== 0)
      .map((addon) => ({ id: addon[0], count: addon[1] }))
      .value();
  };

  _buildAddonsObject = () => {
    return _.chain(this.props.value)
      .map((selectedAddon) => [selectedAddon.id, selectedAddon.count])
      .object()
      .value();
  };

  _clicked = (addonId, e) => {
    e.preventDefault();
    this.props.onAddonClick.call(this, addonId);
  };

  _renderAddon = (addon) => {
    const addonProps = {
      addon,
      key: addon.id,
      defaultGuests: 1,
      totalGuests: this.props.guests,
      selectedGuests: this._selectedAddonsObject[addon.id],
      isSelected: this._selectedAddonsObject[addon.id] > 0,
      update: this.addonUpdated,
      addonAvailability: this.props.addonAvailability,
      date: this.props.date,
      time: this.props.time,
    };

    return <Addon {...addonProps} />;
  };

  _filterAvailableAddonsProps = () => {
    const { date, time, tourTimezone } = this.props;
    const tour_slot = `${date} ${time}`;
    return this.props.availableAddons.filter((addon) => {
      return moment
        .tz(tour_slot, 'YYYY-MM-DD h:mma', tourTimezone)
        .isSameOrAfter(addon.earliest_time_available);
    });
  };

  render() {
    this._selectedAddonsObject = this._buildAddonsObject();
    const addons_before_cutoff_time = this._filterAvailableAddonsProps();

    // Hide addon section if no addons to render
    if (!addons_before_cutoff_time.length) return <></>;

    return (
      <div data-testid="booking-addons" className="BookingRequest-Addons">
        <h5 className="BookingRequest-Addons-title" id="additional-options">
          <FormattedMessage
            id="ADDITIONAL_OPTIONS"
            defaultMessage="Additional options"
          />
        </h5>
        {addons_before_cutoff_time.map(this._renderAddon)}
      </div>
    );
  }
}

export default injectIntl(Addons);
